<template>
<div class="" style="padding-bottom: 90px;">
    <div class="bgp" style="text-align: center; text-shadow: 1px 1px 2px #333; margin-bottom: 90px;">
        <h1 style="color: white; padding-top: 10px; padding-top: 170px;">{{ $t('intH') }}</h1>
        <p style="color: white; padding-top: 10px;">{{ $t('intP') }}</p>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-xl-4 col-md-4 col-sm-12" style="border: 1px solid rgba(236, 236, 236, 0.2);" v-for="(el, i) in 16" :key="i">
                <b-img  @click="slide = i" v-b-modal.modal-2 :src="require('@/assets/INT/int'+(i+1)+'.jpg')" fluid alt="Responsive image"></b-img>
            </div>
        </div>
    </div>

    <b-modal id="modal-2" size="md" style="" hide-footer hide-header>
        <div>
            <b-carousel
                ref="carousel2"
                id="int-carousel"
                v-model="slide"
                :interval="4000"
                background="#ababab"
                img-width="1024"
                img-height="480"
                style="text-shadow: 1px 1px 2px #333;"
                >
                <b-carousel-slide v-for="(el, i) in 16" :key="i" :img-src="require('@/assets/INT/int'+(i+1)+'.jpg')"></b-carousel-slide>
            </b-carousel>
             <div style="text-align: right">
                <button class="cButton" @click="prev()">&lt;</button>
                <button class="cButton" @click="next()">&gt;</button>
            </div>
        </div>
    </b-modal>

</div> 
</template>

<script>

export default {
  name: 'Integrations',
  metaInfo: {
    title: 'Integrations',
  },
  data(){
      return{
       slide: 0,
        }
  },
  async mounted(){
  },

  methods : {
    prev() {
      this.$refs.carousel2.prev();
    },
    next() {
      this.$refs.carousel2.next();
    },
      
  },

  components: {

  },
  props: {

  },
      
 computed: {
  },
}

</script>

<style scoped>
.bgp{
background-image: url("../assets/att.jpg");
background-size: cover;
height: 400px;
}
.center {
margin-left: 45%;
padding-top: 200px;
color: white;
}
.cButton {
  background-color: #2d3037;
  border: none;
  padding-left: 15px;
  padding-right: 15px;
  color: white;
}
.cButton:hover {
  background-color: red;
  border: none;
  padding-left: 15px;
  padding-right: 15px;
  color: white;
}
.underline {
  color: black;
  display: inline-block;
  font-size: 0.875rem;
  padding-bottom:2px;
  background-image: linear-gradient(red, red);
  background-position: 0 100%; /*OR bottom left*/
  background-size: 0% 2px;
  background-repeat: no-repeat;
  transition:
  background-size 0.3s,
  background-position 0s 0.3s; /*change after the size immediately*/
}
.underline:hover {
 background-position: 100% 100%; /*OR bottom right*/
  background-size: 100% 2px;
}



</style>
